import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["confirmationInput", "deleteButton", "deleteForm", "radioButton"]
  static values = {
    defaultButtonText: String,
    deleteBothLabel: String
  }

  validateConfirmation() {
    const isValid = this.confirmationInputTarget.value.toUpperCase() === 'DELETE'
    this.deleteButtonTarget.disabled = !isValid
  }

  updateDeleteOption(event) {
    const option = event.target.value

    if (this.hasDeleteFormTarget) {
      const actionUrl = this.deleteFormTarget.action.split('?')[0]
      this.deleteFormTarget.action = actionUrl + '?delete_option=' + option
    }

    this.deleteButtonTarget.textContent = option === 'both'
      ? this.deleteBothLabelValue
      : this.defaultButtonTextValue
  }

  reset() {
    if (this.hasConfirmationInputTarget) {
      this.confirmationInputTarget.value = ''
    }

    if (this.hasDeleteButtonTarget) {
      this.deleteButtonTarget.disabled = true
      this.deleteButtonTarget.textContent = this.defaultButtonTextValue
    }

    if (this.hasRadioButtonTarget) {
      this.radioButtonTargets[0].checked = true
    }
  }
}
